// Styles
import styles from './CallNumber.module.css';

/**
 * @function CallNumber
 * Describes the current position of the draw sequence
 *
 * @example
 * return (
 *   <CallNumber number={1} visible={true} />
 * )
 */
function CallNumber({ number, visible }: CallNumberProps): JSX.Element {
    return (
        <figure
            className={`${styles.figure}${
                visible === true ? ` ${styles.visible}` : ''
            }`}
        >
            <img
                src={`https://${process.env.REACT_APP_CDN}/play-bingo/images/graphics/graphic-ball-chute.svg`}
                alt="Ball chute"
                className={styles.img}
            />
            {number > 0 ? (
                <figcaption className={styles.caption}>
                    Call no. {number}
                </figcaption>
            ) : (
                <figcaption className={styles.caption}>Starting</figcaption>
            )}
        </figure>
    );
}

/**
 * @interface CallNumberProps
 * Describes the properties required for the CallNumber component
 *
 * @property {number} number Current position in draw sequence
 * @property {boolean} visible show tdhe graphic or not
 */
export interface CallNumberProps {
    number: number;
    visible: boolean;
}

// Exports
export default CallNumber;
